interface ProductLinkInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const platformLogos = [
  {
    src: "https://i.ibb.co/NdnhLqqH/ali.png",
    alt: "AliExpress"
  },
  {
    src: "https://www.svgrepo.com/show/303503/shopify-logo.svg",
    alt: "Shopify"
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/4/4a/Amazon_icon.svg",
    alt: "Amazon"
  },
  {
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIXvb1uc1DLyblcMGgEtWTLtXEYzuBfvZ6UQ&s",
    alt: "Etsy"
  },
  {
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKVO4c8b5IsJUTtIjl5ShRPxonqTUzDvD3vw&s",
    alt: "eBay"
  },
  {
    src: "https://fluxi.co/dev/assets/images/dropi-logo-1.webp",
    alt: "Dropi"
  }
];

export function ProductLinkInput({ value, onChange, placeholder }: ProductLinkInputProps) {
  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-3 pr-[200px] border-2 border-gray-200 rounded-[50px] focus:border-[#3B4A9F] focus:outline-none"
      />

      <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-1.5 pointer-events-none">
        {platformLogos.map((logo, index) => (
          <div key={index} className="w-6 h-6 bg-gray-100 rounded-md flex items-center justify-center p-1">
            <img src={logo.src} alt={logo.alt} className="w-full h-full object-contain" />
          </div>
        ))}
      </div>
    </div>
  );
}
